var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.078%",
    y1: "100%",
    x2: "0%",
    y2: "7.585%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#338BF8",
    offset: "39.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23FAD2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-46.73%",
    y1: "64.95%",
    x2: "32.222%",
    y2: "64.95%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 72,
    cy: 25,
    r: 32
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.2%",
    y: "-25%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.406 32.584C20.458 19.694 27.128 5.144 40.305.086l5.376 14.004c2.376 6.19 2.14 13.091-.653 19.186-2.794 6.094-7.919 10.883-14.246 13.311C20.24 50.634 8.486 45.555 4.528 35.242L.944 25.907c10.541-4.047 22.295 1.033 26.254 11.345l-1.792-4.668z",
    id: "i"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-43.1%",
    y: "-33.4%",
    width: "186.3%",
    height: "183.5%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    opacity: 0.48,
    x: 41,
    y: 48,
    width: 12,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#g)",
    xlinkHref: "#i"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon03);
export default __webpack_public_path__ + "static/media/feature-tile-icon-03.01830cf87cad551b479201b42de5ec5e.svg";
export { ForwardRef as ReactComponent };